"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runOnReadyState = void 0;
var addEventListener_1 = require("../browser/addEventListener");
function runOnReadyState(expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? "load" /* LOAD */ : "DOMContentLoaded" /* DOM_CONTENT_LOADED */;
        (0, addEventListener_1.addEventListener)(window, eventName, callback, { once: true });
    }
}
exports.runOnReadyState = runOnReadyState;
//# sourceMappingURL=runOnReadyState.js.map